// LIB
export { DGSCoreModule } from './lib/modules/dgs-core.module';
export * from './lib/models';
export * from './lib/pipes';
export * from './lib/services';
export * from './lib/shared';

// UI
export { DGSUICoreModule } from './ui/modules/dgs-ui-core.module';
export * from './ui/components';
